export const getFilenameFromUrl = (url: string | null) => {
  if (!url) return null
  try {
    const urlObject = new URL(url)
    const pathname = urlObject.pathname
    const filename = pathname.split('/').pop()
    return filename
  } catch (e) {
    console.error(e)
    return null
  }
}

export const reconstructUrl = (originalUrl: string | null, newFilename: string | null) => {
  if (!originalUrl || !newFilename) return null
  try {
    const urlObject = new URL(originalUrl)
    const pathnameParts = urlObject.pathname.split('/')
    pathnameParts[pathnameParts.length - 1] = newFilename
    urlObject.pathname = pathnameParts.join('/')
    return urlObject.href
  } catch (e) {
    console.error(e)
    return null
  }
}
